import axios from 'axios'

function extractCoupon() {
  var codeCookieValue

  var getCookie = function (name) {
    var value = '; ' + document.cookie
    var parts = value.split('; ' + name + '=')
    if (parts.length == 2) return parts.pop().split(';').shift()
  }

  codeCookieValue = getCookie('discount_code').split('%')[0]

  return codeCookieValue ? codeCookieValue : false
}

$(document).ready(function () {
  axios.get('/checkout').then((res) => {
    const coupon = extractCoupon()

    console.log(coupon)
    if (!coupon) return

    const couponAmount = coupon.replace(/\D/g, '')

    // $('#discount-code').text(coupon)
    $('#discount-amount').text(couponAmount)
    $('.discount-bar').addClass('active')
  })
})
